import React from "react";
import { useTranslation } from "react-i18next";
import DashboardWorkflowCard from "../../../Dashboard/DashboardWorkflowCard";
import WorkflowEmptyState from "./WorkflowEmptyState";
import useFavorites from "../hooks/useFavorites";

export default function WorkflowCardView({
    workflows,
    searchTerm,
    showArchived,
    appId,
    currentApp,
}) {
    const { t } = useTranslation();
    const { isFavorite, reloadFavorites } = useFavorites();

    if (workflows.length === 0) {
        return (
            <WorkflowEmptyState
                searchTerm={searchTerm}
                showArchived={showArchived}
                appId={appId}
                currentApp={currentApp}
            />
        );
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {workflows.map((wf) => (
                <DashboardWorkflowCard
                    key={wf.id}
                    workflow={wf}
                    isFavorite={isFavorite(wf.id)}
                    onFavoriteChange={reloadFavorites}
                />
            ))}
        </div>
    );
}
